import React from 'react'

import XText from '../XText/XText'
import SquareWidget from '../SquareWidget/SquareWidget'

import ClipboardIcon from '../../icons/advantages_1.jpeg'
import Money from '../../icons/money.jpeg'
import DeliveryIcon from '../../icons/mbridelivery_mobile.jpeg'

import './advantages.css'

const Advantages = () => (
  <section className='advantages flex-container--bottom-70'>
    <div className='section__content'>
      <div className='section__title'>
        Наші<XText>переваги</XText>
      </div>
      <div className='advantages__content'>
        <SquareWidget className='square-widget--centered'>
          <div className='advantages__header--mobile'>
            <img src={ClipboardIcon} alt="" />
          </div>
          <div className='advantages__header'>
            <img src={ClipboardIcon} alt="" width={64} height={84} />
          </div>
          <div className='advantages__text'>
            Більше<XText>32.000.000</XText>
            &nbsp;
            запчастин
          </div>
        </SquareWidget>
        <SquareWidget className='square-widget--centered'>
          <div className='advantages__header--mobile'>
            <img src={Money} alt="" />
          </div>
          <div className='advantages__header'>
            <img
              src={Money}
              alt="money"
              width={81}
              height={81}
              style={{ marginLeft: 67 }}
            />
          </div>
          <div className='advantages__text'>
            <XText>Простий</XText>спосіб оплати
          </div>
        </SquareWidget>
        <SquareWidget className='square-widget--centered'>
          <div className='advantages__header--mobile'>
            <img src={DeliveryIcon} alt="" />
          </div>
          <div className='advantages__header'>
            <img
              src={DeliveryIcon}
              alt="delivery"
              width={108}
              height={66}
              style={{ marginLeft: 47, marginTop: 35 }}
            />
          </div>
          <div className='advantages__text'>
            <XText>Швидка доставка</XText> з Польщі
          </div>
        </SquareWidget>
      </div>
    </div>
  </section>
)

export default Advantages
